import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { LocalizationModule } from '../localization/localization.module';
import { SharedUIModule } from '../shared/shared.ui.module';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { NimbusModalComponent } from './components/nimbus-modal/nimbus-modal.component';
import { IThemeDirectiveProvider } from './i-theme-directive.provider';
import { ModalLocalService } from './services/modal.local-service';

@NgModule({
  declarations: [NimbusModalComponent, ConfirmModalComponent],
  imports: [CommonModule, SharedUIModule, A11yModule, OverlayModule, LocalizationModule, MatDialogModule],
  exports: [NimbusModalComponent, ConfirmModalComponent],
  providers: [ModalLocalService],
})
export class ModalModule {
  public static forRoot(themeDirectiveProvider: Type<IThemeDirectiveProvider>): ModuleWithProviders<ModalModule> {
    return {
      ngModule: ModalModule,
      providers: [{ provide: IThemeDirectiveProvider, useClass: themeDirectiveProvider }],
    };
  }
}
